import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyCurrency',
})
export class EmptyCurrencyPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  transform(value: any, currencyCode = 'USD', display = 'symbol', digitsInfo = '1.2-2', locale = 'en-US'): any {
    if (value === '-' || !value) {
      return '-';
    }
    if (Number.isNaN(Number.parseFloat(value))) {
      return value;
    }
    const convertedValue = Number.parseFloat(value);
    if (convertedValue === Number.NaN || convertedValue === 0) {
      return '-';
    }
    return this.currencyPipe.transform(convertedValue, currencyCode, display, digitsInfo, locale);
  }
}
